export default __webpack_public_path__ + "static/media/item-3.1cc4c11e.webp";